import { memo, useState } from "react";
// import {Auth} from "aws-amplify";
import { useNavigate } from "react-router";
import "../../styles/pages/_forgetPassword.scss";

const ForgotPassword = () => {
  const history = useNavigate();
  const [userId, setUserId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const forgotPasswordHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // await Auth.forgotPassword(userId);
      history("/forgotpasswordverification");
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="forgot-wrapper">
      <div className="forgot-container">
        {/* Left Illustration Panel */}
        <div className="illustration-container d-none d-md-block">

          <img
            src="/assets/img/Forgot_password.svg"
            alt="Illustration"
            className="illustration-image"
          />
        </div>

        {/* Right Form Panel */}
        <div className="form-section">
          <img src="/assets/img/HOMEAID.svg" alt="HomeAid Logo" className="mb-4 logo" />
          <h5 className="heading">Forgot your password? Let’s get you back on track</h5>

          <form onSubmit={forgotPasswordHandler}>
            <div className="floating-input mb-4">
              <input
                type="text"
                id="userId"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
                placeholder="Enter your User ID"
              />
              <label htmlFor="userId">User ID</label>
              <img
                src="/assets/img/Person_icon.svg"
                alt="user icon"
                className="floating-icon"
              />
            </div>

            <button
              type="submit"
              className={`btn-p w-100 mb-3 ${isLoading ? "is-loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Request Code"}
            </button>

            <div className="text-center text-muted social-text mb-2">
              -------------- Or --------------
            </div>

            <button
              type="button"
              className="btn-secondary w-100"
              onClick={() => history("/login")}
            >
              Back to Login
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default memo(ForgotPassword);
